<div style="margin-bottom: 40px; font-size: 20px; font-weight: 600">
  Add Business Details
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <formly-form [model]="model" [fields]="fields" [form]="form"></formly-form>
  <button type="submit" pButton class="btn btn-primary mt-6 cursor-pointer" style="font-weight: 600">
    Proceed <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
  </button>
</form>
<!-- <p>Distributor Networks (Raw Form Data):</p>
<pre>{{ form.get('distributorNetworks')?.value | json }}</pre> -->
<!-- <app-custom-toast></app-custom-toast> -->